export const achievements = [
  {
    id: 1,
    title: "First Prize - Srishti International Project Exhibition",
    date: "March 2023",
    icon: "Award",
    description:
      "Won first place for innovative MedBot project at international exhibition",
  },
  {
    id: 2,
    title: "First Prize - Internal Hackathon",
    date: "October 2023",
    icon: "Award",
    description:
      "Software Domain winner at Francis Xavier Engineering College hackathon",
  },
  {
    id: 3,
    title: "Published Patent",
    date: "January 2024",
    icon: "Award",
    description:
      '"MedBot: An AI-integrated Rover for Medicinal Plant Detection"',
  },
];

export const certifications = [
  {
    id: 1,
    title: "Oracle Certified Generative AI Professional",
    issuer: "Oracle",
    date: "August 2025",
    description:
      "Demonstrated expertise in building generative AI applications using Oracle Cloud Infrastructure",
  },
  {
    id: 2,
    title: "Natural Language Processing Fundamentals",
    issuer: "NPTEL",
    date: "October 2023",
    description:
      "Completed comprehensive NLP course covering tokenization, sentiment analysis, and model building",
  },
  {
    id: 3,
    title: "AI Bot Development",
    issuer: "NeubAItics Pvt. Ltd.",
    date: "November 2022",
    description:
      "Hands-on workshop on chatbot architecture, design, and web integration",
  },
];